import * as React from 'react'
import { Link, Route, RouteComponentProps } from 'react-router-dom'
import Plus from '../icons/organizations/Plus'
import AddVehicleTypeModal from '../../containers/global-settings/AddVehicleTypeModal'
import EditVehicleTypeModal from './EditVehicleTypeModal'
import RemoveVehicleTypeModal from '../../containers/global-settings/RemoveVehicleTypeModal'
import SettingList from './SettingList'
import { IVehicleCarType } from 'src/types'
import BackToList from '../ui/BackToList'

interface IVehicleTypePaneProps extends RouteComponentProps {
  carTypes: IVehicleCarType[]
}

export default class VehicleTypePane extends React.Component<IVehicleTypePaneProps> {
  public render() {
    const carTypes = []
    for (const index of Object.keys(this.props.carTypes)) {
      const carType = this.props.carTypes[index]
      carTypes.push({
        label: carType.name,
        id: carType.id
      })
    }
    return (
      <React.Fragment>
        <Route path={`${this.props.match.path}/create`} component={AddVehicleTypeModal} />
        <Route path={`${this.props.match.path}/remove/:id`} component={RemoveVehicleTypeModal} />
        <Route path={`${this.props.match.path}/edit/:id`} component={EditVehicleTypeModal} />
        <BackToList link='/global-settings' className='flex' />
        <div className='pt3'>
          <div className='flex justify-between mb2'>
            <div className='pl3 h3 bold font-blue-grey'>Vehicle Type</div>
            <Link
              className='btn bg-green rounded font-white mr2 flex justify-center items-center'
              to='/global-settings/vehicle-type/create'
            >
              <Plus className='svg-white mr1' />
              Add Vehicle Type
            </Link>
          </div>
          <hr />
          <div>
            <p className='h5 bold pl2 font-black'>Vehicle Type List</p>
            <div className='pl3 pr3 col-4'>
              <SettingList baseUrl={this.props.match.path} settings={carTypes} />
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/VehicleTypePane.tsx